// Status constants — single source of truth for API and frontend status values.
export const API_TICKET_STATUS = Object.freeze({
  NEW: 'NEW',
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
});

export const TICKET_STATUS = Object.freeze({
  NEW: 'new',
  OPEN: 'open',
  IN_PROGRESS: 'in-progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed',
  UNKNOWN: 'unknown',
});

export const STATUS_META = {
  [TICKET_STATUS.NEW]:         { label: 'New',         tone: 'blue',    icon: 'plus-circle', color: "#2563eb"},
  [TICKET_STATUS.OPEN]:        { label: 'Open',        tone: 'indigo',  icon: 'access-time', color: "#e04d01"},
  [TICKET_STATUS.IN_PROGRESS]: { label: 'In Progress', tone: 'amber',  icon: 'clock', color: "#e89820"},
  [TICKET_STATUS.RESOLVED]:    { label: 'Resolved',    tone: 'emerald', icon: 'check-circle', color: "#51a16a"},
  [TICKET_STATUS.CLOSED]:      { label: 'Closed',      tone: 'slate',   icon: 'x-circle', color: "#6b6b76"},
  [TICKET_STATUS.UNKNOWN]:     { label: 'Unknown',     tone: 'slate',   icon: 'help-circle', color: "#6b7280"},
};

export const STATUS_ORDER = Object.freeze([
  TICKET_STATUS.NEW,
  TICKET_STATUS.OPEN,
  TICKET_STATUS.IN_PROGRESS,
  TICKET_STATUS.RESOLVED,
  TICKET_STATUS.CLOSED,
]);

export const ACTIVE_TICKET_STATUSES = Object.freeze([
  TICKET_STATUS.NEW,
  TICKET_STATUS.OPEN,
  TICKET_STATUS.IN_PROGRESS,
]);

// Map backend STATUS code → frontend status key
export const STATUS_MAP = Object.freeze({
  [API_TICKET_STATUS.NEW]: TICKET_STATUS.NEW,
  [API_TICKET_STATUS.OPEN]: TICKET_STATUS.OPEN,
  [API_TICKET_STATUS.IN_PROGRESS]: TICKET_STATUS.IN_PROGRESS,
  [API_TICKET_STATUS.RESOLVED]: TICKET_STATUS.RESOLVED,
  [API_TICKET_STATUS.CLOSED]: TICKET_STATUS.CLOSED,
});
